"use strict";
exports.__esModule = true;
var converter_1 = require("@iota/converter");
var curl_1 = require("@iota/curl");
var transaction_1 = require("@iota/transaction");
var HMAC_ROUNDS = 27;
function addHMAC(transactions, key) {
    var curl = new curl_1["default"](HMAC_ROUNDS);
    var hmac = new Int8Array(curl_1["default"].HASH_LENGTH);
    curl.initialize();
    curl.absorb(key, 0, curl_1["default"].HASH_LENGTH);
    curl.absorb(transaction_1.bundle(transactions), 0, curl_1["default"].HASH_LENGTH);
    curl.squeeze(hmac, 0, curl_1["default"].HASH_LENGTH);
    var transactionsCopy = transactions.slice();
    for (var offset = 0; offset < transactionsCopy.length; offset += transaction_1.TRANSACTION_LENGTH) {
        if (converter_1.tritsToValue(transaction_1.value(transactions, offset)) > 0) {
            transactionsCopy.set(hmac, offset + transaction_1.SIGNATURE_OR_MESSAGE_OFFSET);
        }
    }
    return transactionsCopy;
}
exports["default"] = addHMAC;
//# sourceMappingURL=hmac.js.map